export default __webpack_public_path__ + "static/media/ic-harvesting-2.9faf0724.svg";